import { Injectable } from '@angular/core';
import { QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CheckClientBankAccountQuery, CheckClientBankAccountQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@QueryHandlerFor(CheckClientBankAccountQuery)
@Wrapper(CheckClientBankAccountQueryHandlerBase)
export class CheckClientBankAccountQueryHandler {}
